import useUserLists from './useUserLists'
import { Item } from '../types'

export default function useInListsCount(itemId: Item['id']) {
  const { data } = useUserLists()
  return data?.filter(({ items }) => items.some(({ id }) => id === itemId))
    .length
}
